import React from 'react';
import * as S from './DestinationTrendingUI.styles';
import {defaultTheme} from '@ibibo/build-theme';

import LeftArrowNewIcon from '../../../../Icons/ArrowLeftNew';
import RightArrowNewIcon from '../../../../Icons/ArrowRightNew';
import {useEffect,useRef} from 'react';

import useCarousel from '../../../../../shared/hooks/useCarousel';

const DestinationTrendingUI = ({data, actionHandler, headData}) => {

    const {
        dataList,
        increment,
        decrement,
        leftCursor,
        rightCursor,
        isLeftCursorActive,
        isRightCursorActive,
    } = useCarousel(data, 4);

    const shouldIncrement = useRef(true);

    useEffect(() => {
      let id = setTimeout(() => {
          if (isRightCursorActive && !isLeftCursorActive) { {increment();shouldIncrement.current =true}}
          else if (!isRightCursorActive && isLeftCursorActive) { {decrement();shouldIncrement.current=false}}
          else {

              if (shouldIncrement.current ) {
                  increment()
              }else {
                  decrement()
              }
          }
      }, 3000);
        return () => clearTimeout(id);
    },)

    return(
        <S.MainOuterWrapper>
            <S.MainInnerWrapper>
                <S.BlockHeadWrap>
                    <S.BlockHeadTextWrap>
                        <S.BlockHeadText>{headData.heading}</S.BlockHeadText>
                        <S.BlockHeadTextSubheading>{headData.subHeading}</S.BlockHeadTextSubheading>
                    </S.BlockHeadTextWrap>
                    <S.BlockSliderWrap>
                        <S.TopDestCaroIconWrap>
                            <S.IconInnerWrapCaro>
                                <S.LeftIconWrapCaro onClick={decrement} disabled={!isLeftCursorActive}>
                                <LeftArrowNewIcon width="1.3rem" height="1.3rem"  fill={!isLeftCursorActive ? defaultTheme.colors.grey.lightc2 : ''} disabled={!isLeftCursorActive} />
                                </S.LeftIconWrapCaro>
                                <S.RightIconWrapCaro onClick={increment} disabled={!isRightCursorActive}>
                                <RightArrowNewIcon width="1.3rem" height="1.3rem" fill={!isRightCursorActive ? defaultTheme.colors.grey.lightc2 : ''} disabled={!isRightCursorActive} />
                                </S.RightIconWrapCaro>
                            </S.IconInnerWrapCaro>
                        </S.TopDestCaroIconWrap>
                    </S.BlockSliderWrap>
                </S.BlockHeadWrap>

                <S.BlockConentWrap>
                    <S.SuggestedCardList>
                        {dataList && dataList.map((item, index) => {
                            return <li key={'DestTrendItem' + index}>
                                <S.SuggestedImageWrap
                                    onClick={() => {
                                        actionHandler(item);
                                  }}>
                                    <img src={item.image_url} alt={item.description}/>
                                </S.SuggestedImageWrap>
                                <S.SuggestedCityText>{item.h_text}</S.SuggestedCityText>
                                <S.SuggestedCityTextDescription>{item.description}</S.SuggestedCityTextDescription>
                            </li>
                        })}
                    </S.SuggestedCardList>
                </S.BlockConentWrap>
            </S.MainInnerWrapper>
        </S.MainOuterWrapper>
    )
}

export default DestinationTrendingUI;